export const SERVER_URL = 'https://api.reservista.ru'; //for prod
// export const SERVER_URL = 'https://api-devel.reservista.ru';

/* change in: (can cmd shift f "for prod")
*   here
*   bash_scripts
*   index.html
* */

export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
